(function () {
  const modal = document.getElementById('FreeGiftModal');
  if (!modal) return;

  const open = () => {
    modal.hidden = false;
    document.documentElement.classList.add('overflow-hidden');
  };

  const close = () => {
    modal.hidden = true;
    document.documentElement.classList.remove('overflow-hidden');
  };

  // Close modal (X/backdrop)
  modal.addEventListener('click', (e) => {
    if (e.target.matches('[data-freegift-close]')) close();
  });

  // ----------------------------
  // ✅ CONFIRM SELECTED GIFT
  // ----------------------------
  const confirmBtn = modal.querySelector('#FreeGiftConfirm');

  confirmBtn?.addEventListener('click', async () => {
    const chosen = modal.querySelector('input[name="freegift_choice"]:checked');
    if (!chosen) return alert('Please select a free gift first.');

    confirmBtn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: Number(chosen.value),
              quantity: 1,
              properties: { _free_gift: 'true' }
            }
          ]
        })
      });

      if (!res.ok) throw new Error('Cart add failed');

      close();

      // Optional: if you refresh cart drawer using custom event
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (err) {
      console.error(err);
      alert('Could not add the free gift. Please try again.');
    } finally {
      confirmBtn.disabled = false;
    }
  });

  // ----------------------------
  // ✅ ELIGIBILITY CHECK
  // ----------------------------
  const isEligibleFromElement = (el) => {
    // Product page eligibility
    const pf = el.closest('product-form');
    if (pf?.dataset?.freegiftTrigger === 'true') return true;

    // Collection/card eligibility
    if (el.closest('[data-freegift="true"]')) return true;

    return false;
  };

  // ----------------------------
  // ✅ SUPER RELIABLE TRIGGER
  // Works for: product page, collection quick add, forms, fetch, XHR
  // ----------------------------
  let lastEligibleClick = false;

  // 1) Remember if last click was eligible add-to-cart
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest(
        'button[name="add"], .product-form__submit, .quick-add__submit, button[data-add-to-cart], .offer-add, input[type="submit"]'
      );
      if (!btn) return;

      // Only set true if this click belongs to an eligible product
      lastEligibleClick = isEligibleFromElement(btn);
    },
    true
  );

  const triggerPopupIfEligible = () => {
    if (!lastEligibleClick) return;
    lastEligibleClick = false;

    // Prevent double open
    if (!modal.hidden) return;

    setTimeout(open, 350);
  };

  // 2) Catch collection add-to-cart using FORM submit
  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (!form || !form.matches('form[action^="/cart/add"]')) return;

      // If the submit comes from eligible click, open it
      triggerPopupIfEligible();
    },
    true
  );

  // 3) Catch AJAX add-to-cart using FETCH
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await _fetch.apply(this, args);

    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
      if (url.includes('/cart/add')) {
        triggerPopupIfEligible();
      }
    } catch (_) {}

    return res;
  };

  // 4) Catch AJAX add-to-cart using XHR
  const _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._freeGiftUrl = url;
    return _open.apply(this, arguments);
  };

  const _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('load', () => {
      try {
        const url = String(this._freeGiftUrl || '');
        if (url.includes('/cart/add')) {
          triggerPopupIfEligible();
        }
      } catch (_) {}
    });

    return _send.apply(this, arguments);
  };
})();
